export enum dashboardTypes {
  GET_FILTER_LIST = '@@dashboard/GET_FILTER_LIST',
  GET_FILTER_LIST_SUCCESS = '@@dashboard/GET_FILTER_LIST_SUCCESS',
  GET_FILTER_LIST_FAIL = '@@dashboard/GET_FILTER_LIST_FAIL',

  GET_FILTER_DATA = '@@dashboard/GET_FILTER_DATA',
  GET_FILTER_DATA_SUCCESS = '@@dashboard/GET_FILTER_DATA_SUCCESS',
  GET_FILTER_DATA_FAIL = '@@dashboard/GET_FILTER_DATA_FAIL',
}
